const certifications = [
    {
        "id": "1",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"documentCheck",
        "activity":"documentCheck_S080",
        "operatorNo": "1105",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "initial",
        "appNo": "202100012",
        "completeLists": [
            {
                "completeList": "供膳體檢表",
                "complete": "complete",
                "description": ""
            },
            {
                "completeList": "土地使用說明書",
                "complete": "uncompleted",
                "description": ""
            },
            {
                "completeList": "有機農產品租借自產加工場地、設備合約書",
                "complete": "complete",
                "description": ""
            }
        ],
        "uncompletedList": [
            {
                "item": "farmInformation",
                "comment": "確認農田土壤及灌溉水中的八大重金屬...針對作物需求，進行肥培管理",
                "reply": "uncompleted",
                "replyDescription": "進行中",
            },
            {
                "item": "selfProducedProcessing",
                "comment": "改變有機農產品及有機轉型期農產品之原包裝或原標示",
                "reply": "uncompleted",
                "replyDescription": "更改中",
            },
        ],
    },
    {
        "id": "2",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"documentReview",
        "activity":"documentReview_S30",
        "operatorNo": "1105",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "initial",
        "appNo": "202100012",
        "uncompletedList": [
            {
                "completeList": "提供的記錄未見資材使用、採收等紀錄，請提供",
                "complete": "complete",
                "description": ""
            },
            {
                "completeList": "缺土壤肥力分析報告，請提供",
                "complete": "uncompleted",
                "description": ""
            },
        ]
    },
    {
        "id": "3",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"inspection",
        "activity":"inspection_S20",
        "operatorNo": "1105",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "initial",
        "appNo": "202100012",
        "ncrs": [
            {
                "carNo": "CAR048-01",
                "observation": "未建立標章使用紀錄",
                "regulationNo": "2-13",
                "checklistType": "crop",
                "checklistNos": [
                    {
                        "section": "01",
                        "checklistNo": ["01-5", "01-3"]
                    },
                    {
                        "section": "03",
                        "checklistNo": ["03-1", "03-3"]
                    },
                ]
            },
            {
                "carNo": "CAR048-02",
                "observation": "未保留資材-龍燈精鍊油採購單據",
                "regulationNo": "3-13",
                "checklistType": "group",
                "checklistNos": [
                    {
                        "section": "02",
                        "checklistNo": ["02-1", "02-3"]
                    },
                ]
            }
        ],
        "ncrHistories": [
            {
                "carNo": "CAR048-01",
                "observation": "未建立標章使用紀錄",
                "regulationNo": "2-13",
                "estimatedImprovementDate": "2022-01-27T00:00:00.000+08:00",
                "correctionActionPlan": "建立標章使用紀錄",
                "reviewResult": "supplemented",
                "comment": "尚未補件完成",
                "attachments": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件1.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件2.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "carNo": "CAR048-02",
                "observation": "未保留資材-龍燈精鍊油採購單據",
                "regulationNo": "3-13",
                "estimatedImprovementDate": "2022-01-30T00:00:00.000+08:00",
                "correctionActionPlan": "會保留",
                "reviewResult": "uncompleted",
                "comment": "仍缺少單據",
                "attachments": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件3.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "1",
                        "name": "附件4.pdf",
                        "lastModified": 0
                    }
                ]
            }
        ]
    },
    {
        "id": "4",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"improvementDeadline",
        "activity":"improvementDeadline_S10",
        "operatorNo": "1105",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "initial",
        "appNo": "202100012",
        "ncrs": [
            {
                "observation": "未建立標章使用紀錄",
            },
            {
                "observation": "未保留資材-龍燈精鍊油採購單據"
            }
        ]
    },
    {
        "id": "5",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"documentCheck",
        "activity":"documentCheck_S120",
        "operatorNo": "1105",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "renewal",
        "appNo": "202100016",
    },
    {
        "id": "6",
        "createdOn": "2021-03-15T00:00:00.000+08",
        "phase":"changeReview",
        "activity":"changeReview_S20",
        "operatorNo": "1103",
        "operatorName": "楊小花",
        "region": "domestic",
        "appType":  "change",
        "appNo": "202100072",
        "supplementItems": [
            {
                "id": "basicInfoChange",
                "reviewResult": "reject",
                "comments": "請重新上傳身分證影本",
                "reply": "complete",
            },
            {
                "id": "farmMapChange",
                "reviewResult": "reject",
                "comments": "農場圖標示不清楚",
                "reply": "complete",
            },
        ]
    }
]

export default certifications;